/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { getBankName, getContractData, getInvoices } from 'actions/selfservice';
import InvoicesItem from 'components/Credit24/SelfService/Invoices/InvoicesItem';
import PaymentDetails from 'components/Credit24/SelfService/Invoices/PaymentDetails';
import Collapsible from 'components/common/controls/Collapsible';
import OpenInvoiceSectionMobile from 'components/Credit24/SelfService/Invoices/OpenInvoiceSectionMobile';
import UnpaidInvoiceSection from 'components/Credit24/SelfService/Invoices/UnpaidInvoiceSection';
import UnpaidInvoiceSectionMobile from 'components/Credit24/SelfService/Invoices/UnpaidInvoiceSectionMobile';
import AllPaidInvoiceSection from 'components/Credit24/SelfService/Invoices/AllPaidInvoiceSection';
import { isMobile } from 'utils/helpers';

const propTypes = {
  selfservice: PropTypes.object,
  authentication: PropTypes.object,
  getInvoices: PropTypes.func,
  getContractData: PropTypes.func,
  getBankName: PropTypes.func,
};

class InvoicesContainer extends Component {
  componentDidMount() {
    const {
      authentication: { bankAccount, contracts = [] },
    } = this.props;
    contracts.forEach((contractId) => {
      this.props.getContractData(contractId);
      this.props.getInvoices(contractId);
    });
    this.props.getBankName(bankAccount);
  }

  render() {
    const { authentication, selfservice } = this.props;
    const contractId = authentication.contracts[0];

    const contract = selfservice.contracts[contractId] || {};
    const invoices = selfservice.invoices[contractId];

    const { lateFees } = contract;
    const hasLateFees = COUNTRY === 'AU' && lateFees > 0;

    if (!invoices && !hasLateFees) {
      return null;
    }

    const {
      openInvoices = [],
      paidInvoices = [],
      unpaidInvoices = [],
      unpaidAmount,
      totalAmount,
    } = invoices;

    const openInvoice = openInvoices[0];
    const showUnpaidInvoices = unpaidInvoices.length > 0 || hasLateFees;
    const hasPaidInvoices = !!paidInvoices.length;

    return (
      <>
        {COUNTRY !== 'AU'
          && (
          <div className="content-block">
            <Collapsible
              Title={() => (
                <h3>
                  <FormattedMessage id="selfservice.invoices.paymentDetails.title" />
                </h3>
              )}
              ContentWrapper={({ children }) => (
                <div className="content-block__full-child">
                  {children}
                </div>
              )}
              defaultOpened={!isMobile && paidInvoices.length < 2}
            >
              <PaymentDetails
                referenceNumber={contract.referenceNumber}
                toPay={totalAmount}
                customerBank={selfservice.customerBankName || authentication.bank}
              />
            </Collapsible>
          </div>
          )}
        {showUnpaidInvoices && isMobile
          && (
          <div className="content-block txt-center">
            <h3 className="txt-center txt-error">
              <FormattedMessage
                id={hasLateFees ? 'selfservice.dashboard.invoice.lateFee' : 'selfservice.invoices.unpaid'}
                values={{
                  value: unpaidInvoices.length,
                  formattedValue: <strong>{unpaidInvoices.length}</strong>,
                }}
              />
            </h3>
            <UnpaidInvoiceSectionMobile
              invoices={unpaidInvoices}
              contractId={contractId}
              lateFees={hasLateFees ? lateFees : null}
            />
          </div>
          )}
        {showUnpaidInvoices && !isMobile
          && (
          <div className="content-block content-block--type-warning">
            <h3 className="content-block__title content-block__title--type-warning">
              <FormattedMessage
                id={hasLateFees ? 'selfservice.dashboard.invoice.lateFee' : 'selfservice.invoices.unpaid'}
                values={{
                  value: unpaidInvoices.length,
                  formattedValue: <strong>{unpaidInvoices.length}</strong>,
                }}
              />
            </h3>
            <UnpaidInvoiceSection
              unpaidInvoices={unpaidInvoices}
              contractId={contractId}
              unpaidAmount={unpaidAmount}
              lateFees={hasLateFees ? lateFees : null}
            />
          </div>
          )}
        {openInvoice && !isMobile
          && (
          <div className="content-block">
            <h3>
              <FormattedMessage id="selfservice.invoices.pending" />
            </h3>
            <div className="invoices">
              <p className="invoices__text">
                <FormattedMessage id="selfservice.invoices.paymentDateInfo" />
              </p>
            </div>
            {openInvoices.map((invoice) => (
              <InvoicesItem
                key={invoice.id}
                invoice={invoice}
                contractId={contractId}
                showInvoiceNumber={COUNTRY !== 'AU'}
              />
            ))}
          </div>
          )}
        {openInvoice && isMobile
          && (
          <div className="content-block txt-center">
            <OpenInvoiceSectionMobile
              invoice={openInvoice}
              contractId={contractId}
            />
          </div>
          )}
        {!unpaidInvoices.length && !hasLateFees && !openInvoice
          && (
          <div className="content-block">
            <AllPaidInvoiceSection
              nextInvoicingDate={COUNTRY === 'AU'
                ? contract.nextDueDate
                : contract.nextInvoicingDate}
              hasPaidInvoices={hasPaidInvoices}
            />
          </div>
          )}
        {paidInvoices.length > 0
          && (
          <div className="content-block">
            <h3>
              <FormattedMessage id="selfservice.invoices.paid" />
            </h3>
            <div className="content-block__full-child">
              <div className="invoice-item invoice-item--type-header">
                <span className="invoice-item__desc">
                  <span className="invoice-item__date">
                    <FormattedMessage id="selfservice.invoices.header.paymentDate" />
                  </span>
                </span>
                <span className="invoice-item__amount">
                  <FormattedMessage id="selfservice.invoices.header.invoiceAmount" />
                </span>
              </div>
              {paidInvoices.map((paidInvoice) => (
                <InvoicesItem
                  invoice={paidInvoice}
                  key={paidInvoice.id}
                  contractId={contractId}
                  showInvoiceNumber={COUNTRY !== 'AU'}
                  list
                />
              ))}
            </div>
          </div>
          )}
      </>
    );
  }
}

InvoicesContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    selfservice: state.selfservice,
    authentication: state.authentication,
  }),
  { getContractData, getInvoices, getBankName }
)(InvoicesContainer);
